export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_zh_TW.9ab7f263087768f7.json"